module.exports = __webpack_public_path__ + "static/media/io_unit_off.d90babfc.jpg";